enum PriorApprovalStatus {
  Pending = 'Pending',
  Rejected = 'Rejected',
  Approved = 'Approved',
}

export default PriorApprovalStatus;
